import callAPI from "@helpers/network";
import LandingPageServices from "@services/landing-page";

export const LANDING_PAGE_API = {
  GET_BANNER: async () => {
    return callAPI(LandingPageServices.getBanner());
  },
  GET_TESTIMONY: async () => {
    return callAPI(LandingPageServices.getTestimony());
  },
  GET_BACKGROUND_lEAD: async () => {
    return callAPI(LandingPageServices.getBackgroundLead());
  },
};
